import {Component, store, setState} from 'Generic';

export default class Gateways extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('#payment_gateways'),
      state: store.state,
    });
  }

  render() {
    let gatewayList = this.state.selected_plan.gateways;
    let selectedGatewayKey = this.state.selected_gateway;
    let mobileGatewayElement = document.querySelector('.payments-select-box');
    let desktopGatewayHtml = '';
    let mobileGatewayHtml = '';

    let cardLess = gatewayList.find(gateway => gateway['logical_key'] === this.state.cardless_gateway_name);

    if (cardLess) {
      console.log('isCardLess', cardLess);

      setState({
        selected_gateway: cardLess.logical_key,
        selected_gateway_name: cardLess.name,
      });

      return;
    }

    if (gatewayList) {
      let selectedGateway = gatewayList.find(gateway => gateway.logical_key == selectedGatewayKey);

      if (!selectedGateway) {
        selectedGateway = gatewayList[0];
        let key = selectedGateway.logical_key;
        let name = selectedGateway.name;
        setState({selected_gateway: key, selected_gateway_name: name});
      }

      for (const gateway of gatewayList) {
        if (conditionalGateways[gateway.logical_key] === false) continue;
        desktopGatewayHtml += `
          <div class="col-sm-4 gateway-method payment_selection_box ${selectedGateway.logical_key == gateway.logical_key && 'active'}" id="${
          gateway.logical_key
        }_box_icon" data-name="${gateway.logical_key}" data-gateway-text="${gateway.name}">
            <div class="gateway-method-inr" data-gateway-type="recurring" data-eventcategory="Order Cart" data-eventaction="Payment gateway select" data-eventlabel="${
              gateway.logical_key
            }" data-eventvalue="1">
              <span></span>
            </div>
          </div>
        `;

        mobileGatewayHtml += `<option ${selectedGateway.logical_key == gateway.logical_key && 'selected'} value="${gateway.logical_key}" data-name="${
          gateway.logical_key
        }" data-gateway-text="${gateway.name}">${gateway.name}</option>`;
      }
    }

    this.element.innerHTML = desktopGatewayHtml;
    mobileGatewayElement.innerHTML = mobileGatewayHtml;
  }
}
